export default "__VITE_ASSET__DS9HVY1r__"